import { faAngleLeft } from "@fortawesome/free-solid-svg-icons/faAngleLeft";
import React from "react";
import { ChatWidgetCurrent } from "../../model/chat-wiget/types/ChatWigetCurrent.enum";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Flex } from "../Flex";
import { Spacing } from "../../theme/Spacing";
import { Button } from "../Button";
import { TestIDs } from "../../tests/types/testIds";
import { Text } from "../Text";
import { AtiraIcon } from "../AtiraIcon";
import { faRobot } from "@fortawesome/free-solid-svg-icons/faRobot";

const Container = styled(Flex)`
  align-items: center;
  min-height: 3.5rem;
  padding: 0 ${Spacing.m};
  border: 1px solid #e5e7eb;
  background-color: #f9fafb;
`;

const BackButton = styled(Button)`
  background-color: transparent;
  margin: 0;
  font-weight: 600;
  color: ${({ theme }) => theme.main};
  padding-inline: ${Spacing.l};
  font-size: 1.125rem;

  html[dir="rtl"] & > div > svg {
    rotate: 180deg;
  }
`;

type ChatWidgetHeaderProps = {
  onBack: VoidFunction;
  current: ChatWidgetCurrent;
  children?: React.ReactNode;
};

export const ChatWidgetMenuHeader: React.FC<ChatWidgetHeaderProps> = ({
  onBack,
  children,
  current,
}) => {
  const { t } = useTranslation();

  if (current === ChatWidgetCurrent.DEFAULT) {
    return null;
  }

  return (
    <Container>
      <Flex alignItems="center" gap="s">
        <AtiraIcon icon={faRobot} color="main" size="2x" />
        <Text color="main">{t("floatingMenu.aiChat.title")}</Text>
      </Flex>
      {children}
    </Container>
  );
};
